import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { GuidedTourStep } from '../guided-tour.model';

let nextInstanceId = 0;

/** The card of a tour step: where it is in the tour, what it explains and how to move on. */
@Component({
  selector: 'nr-guided-tour-step',
  imports: [A11yModule, TranslatePipe],
  templateUrl: './guided-tour-step.html',
  styleUrl: './guided-tour-step.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidedTourStepComponent {
  private readonly instanceId = nextInstanceId++;

  readonly step = input.required<GuidedTourStep>();

  readonly stepNumber = input.required<number>();

  readonly stepCount = input.required<number>();

  readonly next = output();

  readonly skip = output();

  readonly done = output();

  readonly isLastStep = computed(() => this.stepNumber() >= this.stepCount());

  readonly headingId = `guided-tour-step-title-${this.instanceId}`;

  readonly textId = `guided-tour-step-text-${this.instanceId}`;

  /** Escape skips the tour only, so the dialog the tour is shown in stays open. */
  onEscape(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.skip.emit();
  }
}
